export default __webpack_public_path__ + "static/logo-white pisa-61df5d14853283a9d8ae374232d40a41.png";